export default __webpack_public_path__ + "static/media/next (1).d1e77de6.svg";